import { AdminFinancialMonthlyPoint } from "./AdminFinancialMonthlyPoint"
import { AdminFinancialSummary } from "./AdminFinancialSummary"
import { AdminStoreFinancialMetric } from "./AdminStoreFinancialMetric"

export class AdminFinancialMetrics {
  summary: AdminFinancialSummary

  monthlySeries: AdminFinancialMonthlyPoint[]

  topStores: AdminStoreFinancialMetric[]

  constructor(data: Partial<AdminFinancialMetrics> = {}) {
    this.summary = new AdminFinancialSummary(data.summary)

    this.monthlySeries = data.monthlySeries?.map((item) => new AdminFinancialMonthlyPoint(item)) ?? []

    this.topStores = data.topStores?.map((item) => new AdminStoreFinancialMetric(item)) ?? []
  }
}
